export default __webpack_public_path__ + "static/media/logo_parodontax.d13ac355.svg";